import Vue from 'vue';

const success = (response, resolve) => {
  resolve(response);
};

const failed = (error, reject) => {
  reject(error.response.data);
};

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.post('/poweroffice/sync')
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/poweroffice/sync.js